(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lu-resources"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lu-section')) {
  class LeistungsSection extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const tabs = [...this.querySelectorAll('[role="tab"]')];
      const activate = (tab, focus = false) => {
        tabs.forEach(item => {
          const active = item === tab;
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
          this.querySelector(`[id="${item.getAttribute('aria-controls')}"]`).hidden = !active;
        });
        if (focus) tab.focus();
      };
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => activate(tab), options);
        tab.addEventListener('keydown', event => {
          const next = { ArrowRight: (i + 1) % tabs.length, ArrowLeft: (i - 1 + tabs.length) % tabs.length, Home: 0, End: tabs.length - 1 }[event.key];
          if (next !== undefined) { event.preventDefault(); activate(tabs[next], true); }
        }, options);
      });
      const menu = this.querySelector('.menu');
      const nav = this.querySelector('.nav');
      const closeMenu = () => { if (menu) { menu.setAttribute('aria-expanded', 'false'); nav.dataset.open = 'false'; } };
      menu?.addEventListener('click', () => {
        const open = menu.getAttribute('aria-expanded') !== 'true';
        menu.setAttribute('aria-expanded', String(open)); nav.dataset.open = String(open);
      }, options);
      const dialog = this.querySelector('dialog');
      if (this.dataset.zoomEnabled !== 'true') this.querySelectorAll('[data-zoom]').forEach(button => { button.disabled = true; });
      let trigger;
      this.addEventListener('click', event => {
        const zoom = event.target.closest('[data-zoom]');
        if (zoom && dialog && this.dataset.zoomEnabled === 'true') {
          const source = zoom.querySelector('img');
          if (!source) return;
          trigger = zoom;
          dialog.querySelector('h3').textContent = zoom.dataset.zoomTitle;
          const image = dialog.querySelector('img');
          image.src = source.src; image.alt = source.alt;
          image.width = source.naturalWidth; image.height = source.naturalHeight;
          dialog.showModal();
        }
        const anchor = event.target.closest('a[data-lu-target]');
        if (anchor && anchor.getAttribute('href')?.startsWith('#')) {
          const target = [...document.querySelectorAll('[data-lu-anchor]')].find(item => item.dataset.luAnchor === anchor.getAttribute('href').slice(1));
          if (target) { event.preventDefault(); closeMenu(); target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' }); target.setAttribute('tabindex', '-1'); target.focus({ preventScroll: true }); history.replaceState(null, '', anchor.getAttribute('href')); }
        }
      }, options);
      dialog?.querySelector('.close').addEventListener('click', () => dialog.close(), options);
      dialog?.addEventListener('close', () => trigger?.focus({ preventScroll: true }), options);
      dialog?.addEventListener('click', event => {
        const r = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom)) dialog.close();
      }, options);
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && menu?.getAttribute('aria-expanded') === 'true') {
          const returnFocus = nav.contains(document.activeElement);
          closeMenu();
          if (returnFocus) menu.focus();
        }
      }, options);
      this.addEventListener('shopify:block:select', event => {
        const panel = event.target.closest('[data-lu-panel]');
        if (panel) activate(tabs.find(tab => tab.getAttribute('aria-controls') === panel.id));
        event.target.closest('details')?.setAttribute('open', '');
      }, options);
      if (nav) {
        this.observer = new IntersectionObserver(entries => {
          for (const entry of entries) if (entry.isIntersecting) nav.querySelectorAll('a').forEach(a => {
            if (a.getAttribute('href') === '#' + entry.target.dataset.luAnchor) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
          });
        }, { rootMargin: '-20% 0px -60% 0px' });
        this.observeSections = () => document.querySelectorAll('[data-lu-anchor]').forEach(section => this.observer.observe(section));
        this.observeSections();
        document.addEventListener('shopify:section:load', this.observeSections, options);
        document.addEventListener('DOMContentLoaded', this.observeSections, options);
        const followHash = () => {
          const target = [...document.querySelectorAll('[data-lu-anchor]')].find(item => '#' + item.dataset.luAnchor === location.hash);
          target?.scrollIntoView();
        };
        window.addEventListener('hashchange', followHash, options);
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', followHash, options);
        else followHash();
      }
    }
    disconnectedCallback() { this.abort?.abort(); this.abort = null; this.observer?.disconnect(); }
  }
  customElements.define('lu-section', LeistungsSection);
}
  } catch(e) { console.error(e); }
})();

})();
